import css from 'styled-jsx/css';
import { display, colorHighlight } from 'styles/css-constants';

export default css`
  .ProductTeaser__heading :global(h2) {
    margin-bottom: 1rem;
    font-family: ${display};
    font-size: var(--fontScale3);
  }

  .ProductTeaser__heading :global(a) {
    border-bottom: 1px solid ${colorHighlight};
    color: inherit;
  }
`;
